"use client"
import React from 'react'
import styles from './styles.module.scss'
import SvgArrowLeft from '@/src/assets/svgs/collection/arrow-left-full.svg'

type Theme = 'primary' | 'inverted'

interface Props {
    onClick: () => void
    className?: string
    theme?: Theme
}

export default function BackButtonModal(props: Props) {
    return (
        <div
            onClick={props.onClick}
            className={`${styles.close} ${props.className ?? ""} ${props.theme === 'primary' || props.theme === undefined ? styles.primary : styles.inverted}`}>
            <SvgArrowLeft className={styles.closeSvg} />
        </div>
    )
}
